/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientPrincipal,
  Role,
} from '../models';
import {
    ClientPrincipalFromJSON,
    ClientPrincipalToJSON,
    RoleFromJSON,
    RoleToJSON,
} from '../models';

export interface PostRolesRequest {
    clientPrincipal?: ClientPrincipal;
}

/**
 * 
 */
export class RolesApi extends runtime.BaseAPI {

    /**
     * Gets a list of roles
     * Get Roles
     */
    async getRolesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/role/my-roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Gets a list of roles
     * Get Roles
     */
    async getRoles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.getRolesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a list of roles via POST request
     * Post Roles
     */
    async postRolesRaw(requestParameters: PostRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/role`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientPrincipalToJSON(requestParameters.clientPrincipal),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Gets a list of roles via POST request
     * Post Roles
     */
    async postRoles(requestParameters: PostRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.postRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
